import React, {
    useCallback,
    useEffect,
    useRef,
    useState,
    memo,
} from 'react'
import {
    Alert,
    Button,
    Col,
    Collapse,
    Row,
} from 'react-bootstrap'
import { colors } from '../../../../styles/colors'
import { ArrowBigIcon } from '../../../Icons/ArrowBigIcon'
import { StyledCollapseTrigger } from '../formHelper'
import { useTranslation } from 'react-i18next'
import { MdLibraryAdd } from 'react-icons/md'
import { emptyGuid } from '../../../../utils/emptyGuid'
import ModalComponent from '../../../Modals/ModalComponent'
import { getLanguageValue } from '../../../../utils/getLanguageValue'
import { formatedDate } from '../../../../utils/formatedDate'
import { FileTypeIcon } from '../../../../utils/getFileTypeIcon'
import apiClient from '../../../../utils/api/apiClient'
import { APIEndpoints } from '../../../../utils/api/apiConfig'
import DocumentInfoIcon from "../../../../assets/icons/document_info.png"
import DocumentDeleteIcon from "../../../../assets/icons/document_delete.png"
import DocumentUploadIcon from "../../../../assets/icons/document_up.png"
import DocumentHistoryIcon from "../../../../assets/icons/document_history.png"
import styled from 'styled-components';
import UploadDocumentModal from '../../../DocumentsOGIS/UploadDocumentModal'
import HistoryDocumentModal from '../../../DocumentsOGIS/HistoryDocumentModal'
import { makeCall } from '../../../../utils/api/makeCall'
import useMountEffect from '../../../../utils/hooks/useMountEffect';
import { Spinner } from 'react-bootstrap'
const StyledImage = styled.div`
height:24px;
width:24px;
background-size: contain;
background-image: none;
background-image: url(${props => props.image ? props.image : ""});
`
const StyledDocumentWrapper = styled.a`
    min-height: 48px;
    color: ${colors.gray4};
    small {
        color: ${colors.gray3};
    }
    display: flex;
    align-items: center;
    margin: 5px 5px 5px 0 ;
    cursor: pointer;
`
const AssetDocuments = memo(
    ({
        objectId,
        collapsible,
    }) => {
        const [/*errorStates*/, setErrorStates] = useState({})
        const [/*loadingStates*/, setLoadingStates] = useState({})

        const [loadingDocuments, setLoadingDocuments] = useState(false)
        const [opened, setOpened] = useState(!collapsible)
        const [documents, setDocuments] = useState([])
        const [document, setDocument] = useState(null)
        const ref = useRef()

        const mountedRef = useRef(true)
        const [openDeleteModal, setOpenDeleteModal] = useState(false)
        const [openUploadModal, setOpenUploadModal] = useState(false)
        const [openHistoryModal, setOpenHistoryModal] = useState(false)
        const [useFileUpload, setUseFileUpload] = useState(false)
        const handleClickCollapse = useCallback(() => {
            setOpened((prev) => !prev)
        }, [setOpened])
        const openUploadFile = (doc) => {
            setDocument(doc);
            setUseFileUpload(true)
            setOpenUploadModal(true)
        }
        const handleClose = (refresh) => {
            setOpenDeleteModal(false)
            setOpenUploadModal(false)
            setUseFileUpload(false)
            setOpenHistoryModal(false)
            if (refresh) {
                loadDocuments()
            }

        }
        async function removeDocument(documentId) {
            await makeCall('removeDocument', async () => {
                await apiClient.deleteJson(APIEndpoints.documentAdmin(documentId).documents)
            }, setErrorStates, setLoadingStates)
        }
        const handleDeleteDocument = async () => {
            await removeDocument(document.id)
            handleClose(true)
        }
        const { t } = useTranslation()
        const loadDocuments = () => {
            setLoadingDocuments(true)
            const params = {
                threadId: emptyGuid,
            }
            apiClient.getJson(APIEndpoints.object(objectId).documents, params).then(resp => {
                if (!mountedRef.current) return null
                setDocuments(resp)
                setLoadingDocuments(false)
            })
                .catch(error => console.log(error))
        }
        useMountEffect(() => {
            loadDocuments()
        })
        //Cleanup Function
        useEffect(() => {
            return () => { mountedRef.current = false }
        }, [])
        if (loadingDocuments && opened) {
            return (
                <div className='d-flex justify-content-center'>
                    <Spinner animation='border' variant='primary' />
                </div>
            );
        }
        return (
            <div ref={ref}>
                {collapsible ? (
                    <StyledCollapseTrigger onClick={handleClickCollapse}>
                        <h2>
                            <ArrowBigIcon
                                variant={opened ? 'down' : 'right'}
                                color={colors.textColor}
                                width={'23px'}
                                height={'23px'}
                            />
                            {t('documents:documents')}
                        </h2>
                    </StyledCollapseTrigger>
                ) : (
                    <h2>{t('documents:documents')}</h2>
                )}
                <Collapse in={opened}>
                    <div className='spacing-down'>
                        {documents.length === 0 && (

                            <Alert variant='info'>
                                {t('documents:noDocumentsExists')}
                            </Alert>
                        )}
                        {documents.map((item, index) => {
                            return (
                                <Row className='added-row' key={index}>
                                    <Col>
                                        <div className="d-flex justify-content-start">
                                            <StyledDocumentWrapper href={item.url} download={item.name} filename={item.name} target="_blank">
                                                <FileTypeIcon fileType={item.type} />
                                                <div >
                                                    <div className='fw-bold'>{item.name || ''}</div>
                                                    {getLanguageValue(item.description.values) && <div>
                                                        <small className='text-uppercase'>{getLanguageValue(item.description.values)}</small>
                                                    </div>}
                                                    <div>
                                                        <small className='text-uppercase'>{formatedDate(item.uploadtime ?? '')} - {item.uploadByDisplayName ?? ''}</small>
                                                    </div>
                                                </div>
                                            </StyledDocumentWrapper>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="d-flex justify-content-end">
                                            {item.hasVersions && <div data-toggle="tooltip" data-placement="right" title={t('documents:history')}>
                                                <StyledImage style={{ cursor: "pointer" }} image={DocumentHistoryIcon} onClick={() => { setDocument(item); setOpenHistoryModal(true) }} />
                                            </div>}
                                            <div data-toggle="tooltip" data-placement="right" title={t('documentAdmin:upload')}>
                                                <StyledImage style={{ cursor: "pointer" }} image={DocumentUploadIcon} onClick={() => openUploadFile(item)} />
                                            </div>
                                            <div data-toggle="tooltip" data-placement="right" title={t('delete')}>
                                                <StyledImage style={{ cursor: "pointer" }} image={DocumentDeleteIcon} onClick={() => { setDocument(item); setOpenDeleteModal(true) }} />
                                            </div>
                                            <div data-toggle="tooltip" data-placement="right" title={t('documentAdmin:description')}>
                                                <StyledImage style={{ cursor: "pointer" }} image={DocumentInfoIcon} onClick={() => { setDocument(item); setOpenUploadModal(true) }} />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            )
                        })}
                        <Button onClick={() => openUploadFile(null)} >
                            <MdLibraryAdd className='me-3' />
                            {t('documents:addDocuments')}
                        </Button>
                        {openDeleteModal && (<ModalComponent
                            ModalTitle={document?.name}
                            functionButton1={() => handleDeleteDocument()}
                            textButton1={t('delete')}
                            variantButton1="danger"
                            variantBody="alert-danger"
                            BodyPart1={t('documents:deleteDocumentBody')}
                            functionCancel={() => { setOpenDeleteModal(false) }}
                        />)}
                        {openUploadModal && (<UploadDocumentModal
                            objectId={objectId}
                            threadId={emptyGuid}
                            handleClose={handleClose}
                            documentData={document}
                            useFileUpload={useFileUpload}
                            fileTypes={document ? [document?.type] : null}
                        />)}
                        {openHistoryModal && (<HistoryDocumentModal
                            documentData={document}
                            handleClose={handleClose}
                        />)}
                    </div>
                </Collapse>
            </div>
        )
    }
)

export default AssetDocuments
